__turbopack_context__.v({
  "active": "PageScroll-module-scss-module__PfL5EW__active",
  "dark": "PageScroll-module-scss-module__PfL5EW__dark",
  "light": "PageScroll-module-scss-module__PfL5EW__light",
  "link": "PageScroll-module-scss-module__PfL5EW__link",
  "nav": "PageScroll-module-scss-module__PfL5EW__nav",
});
